import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { SelfAverageTimeInCallsScoreEntity } from '../../../core/domain/entities/scores/self-average-time-in-calls-score.entity';

export interface ISelfAverageTimeInCallsScorePersistenceResponse {
  [IWorkingSessionsAnalyticsActivityEnum.TotalSessionCallDuration]: string;
  [IWorkingSessionsAnalyticsActivityEnum.CallDayCount]?: string;
  [IWorkingSessionsAnalyticsActivityEnum.CallWeekCount]?: string;
}

export class SelfAverageTimeInCallsScoreMapper
  implements Omit<Mapper<SelfAverageTimeInCallsScoreEntity, any>, 'toResponse'>
{
  toDomain(
    record: ISelfAverageTimeInCallsScorePersistenceResponse
  ): SelfAverageTimeInCallsScoreEntity {
    return SelfAverageTimeInCallsScoreMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfAverageTimeInCallsScorePersistenceResponse
  ): SelfAverageTimeInCallsScoreEntity {
    const entity = SelfAverageTimeInCallsScoreEntity.create({
      timeInCallsScore: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalSessionCallDuration]
      ),
      count: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.CallWeekCount] ??
          record[IWorkingSessionsAnalyticsActivityEnum.CallDayCount]
      ),
    });
    return entity;
  }
}
